<template>
  <div class="DateDropDownSelect" :class="getStyle()">
    <div class="dis-block">
      <!-- 年 月 季度 -->
      <el-select
        v-model="selectValve"
        :style="{ width: selectWidth + 'px' }"
        class="drop-down-select"
        placeholder="请选择"
      >
        <el-option
          v-for="itemc in holidayYear"
          :key="itemc.label"
          @click.native.prevent="handleSelectYear(itemc.value)"
          :label="itemc.label"
          :value="itemc"
        />
      </el-select>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
  name: 'DateDropDownSelect',
  props: {
    textSelectData: Array,
    selectApi: String,
  },
  data() {
    return {
      year: '',
      month: '',
      day: '',
      booDecideTitle: false,
      selectValve: '',
      selectValve1: '',
      selectWidth: 60,
      selectThird: '',
      selectChildData: {},
      childData: false,
      childThirdData: false,
      childData1: {},
      watchNewm: '',
      watchNewy: '',
      watchMootm: '',
      currentChartsList: null,

      holidayYear: [
        {
          label: '2025',
          value: '2025',
        },
        {
          label: '2024',
          value: '2024',
        },
        {
          label: '2023',
          value: '2023',
        },
      ],
    };
  },
  mounted() {
    this.selectValve = this.holidayYear[0].label;
  },
  methods: {
    getStyle() {
      let style = {};
      switch (this.componentName) {
        case 'V1Style':
          style['V1Style'] = true;
          break;
        case 'V2Style':
          style['V2Style'] = true;
          break;
        case 'V3Style':
          style['V3Style'] = true;
          break;
        case 'V4Style':
          style['V4Style'] = true;
          break;
        case 'V5Style':
          style['V5Style'] = true;
          break;
        default:
          break;
      }
      return style;
    },
    handleSelectYear(val) {
      this.selectValve = val;
    },
  },
};
</script>

<style lang="scss" scoped>
.DateDropDownSelect {
  position: relative;
}

.drop-down-select {
  margin-left: 4px;
}

:deep().drop-down-select .el-input__inner {
  /* width: 72px; */
  height: 22px;
  line-height: 22px;
  padding-left: 10px;
  padding-right: 20px;
  background: none;
  border: 1px solid #148cdb;
  color: #03b8ca;
  font-size: 12px;
  position: relative;
}

:deep().el-input--small .el-input__icon {
  line-height: 22px;
}

:deep().el-input__suffix {
  right: 0;
  top: -8px;

  .el-input__suffix-inner {
    margin: 0;
  }
}

:deep().drop-down-select {
  &:nth-child(n + 2) {
    .el-input__inner {
      width: 60px;
    }
  }
}

:deep().el-select__popper.el-popper {
  background: none !important;
}

:deep().el-icon-arrow-up:before {
  color: #00f4fd;
}

.V3Style {
  :deep().drop-down-select .el-input__inner {
    width: 94px;
    height: 24px;
    line-height: 22px;
    padding-left: 10px;
    padding-right: 20px;
    background: none;
    border: 1px solid #148cdb;
    color: #03b8ca;
    font-size: 12px;
    background: linear-gradient(to top, #0c2b67, #031639, #0c2b67);
  }

  :deep().el-icon-arrow-up:before {
    color: #1597e6;
  }
}

.V4Style {
  :deep().drop-down-select .el-input__inner {
    width: 80px;
    height: 22px;
    line-height: 22px;
    padding-left: 10px;
    padding-right: 20px;
    background: none;
    border: 1px solid #8d77d8;
    color: #fff;
    font-size: 12px;
  }

  :deep().el-icon-arrow-up:before {
    color: #8d77d8;
  }
}

.V5Style {
  :deep().drop-down-select .el-input__inner {
    width: 80px;
    height: 22px;
    line-height: 22px;
    padding-left: 10px;
    padding-right: 20px;
    background: none;
    border: 1px solid #03a252;
    color: #fff;
    font-size: 12px;
  }

  :deep().el-icon-arrow-up:before {
    color: #03a252;
  }
}
@media screen and (min-width: 3300px) {
  :deep().el-input__suffix {
    top: -4px !important;
  }
  :deep().drop-down-select .el-input__inner {
    height: 33px !important;

    font-size: 18px !important;
  }
}
</style>
